// Sugalarm — labeled form field. Wraps any input/select element.

import type { ReactNode } from "react";
import styles from "./Field.module.css";

interface FieldProps {
  label: string;
  right?: ReactNode;
  error?: string | null;
  children: ReactNode;
}

export function Field({ label, right, error, children }: FieldProps) {
  return (
    <label className={styles.field}>
      <span className={styles.head}>
        <span>{label}</span>
        {right}
      </span>
      {children}
      {error ? <span className={styles.error}>{error}</span> : null}
    </label>
  );
}

export const inputClass = styles.input;
